import { UAParser } from "ua-parser-js"

const agent = UAParser(navigator.userAgent)

/**
 * Returns true if the user is on mobile
 */
export function isMobile () {
  return agent.device.type === "mobile"
}
